export const EXTERNAL_FORM_FONTS = ['Inter', 'Montserrat', 'Roboto', 'Poppins', 'Nunito'];

export const EXTERNAL_FORM_DEFAULTS = {
  logo: null,
  title: '¡A un paso más cerca de tu cliente!',
  subtitle: 'Obtén cotizaciones en segundos',
  fontFamily: 'Inter',
  primaryColor: '#1F61FF',
  textColor: '#1F2937',
  logoPosition: 'left',
};

export const LOGO_POSITIONS = ['left', 'center'];

export const isHexColor = (value) => /^#[0-9A-F]{6}$/.test(value || '');

export const isExternalFormValid = (form) => Boolean(
  form
  && typeof form.title === 'string'
  && form.title.trim()
  && form.title.trim().length <= 120
  && typeof form.subtitle === 'string'
  && form.subtitle.trim()
  && form.subtitle.trim().length <= 200
  && EXTERNAL_FORM_FONTS.includes(form.fontFamily)
  && isHexColor(form.primaryColor)
  && isHexColor(form.textColor),
);

export const externalFormFontFamily = (fontFamily) => `'${fontFamily}', sans-serif`;
